// extracted by mini-css-extract-plugin
module.exports = {"PostIt":"PostItMessage_PostIt__26jdQ","Close":"PostItMessage_Close__3F1hw"};